import axios from 'axios';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import warning3 from '../../assets/images/backoffice/warning3.png';
import { Checkbox } from '../../components/common/Checkbox/Checkbox';
import { SETTINGS_VIRTUAL_OFFICE } from '../../routes/routes';
import { H3, P1, P2 } from '../../styles/FontStyles';
import { Flexed } from '../../styles/GlobalComponents';
import { colors, lightTheme } from '../../styles/GlobalStyles';
import { Icon, IconXCircle } from '../../styles/Icons';
import { Button } from '../../components';

export const FirstLogin = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');
  const { t: dashboard } = useTranslation('dashboard');
  const [checkbox, setCheckbox] = useState(false);

  const firstLogin = async () => {
    try {
      await axios.put(`/user/set-first-login-popup-checked`);
      history.push(SETTINGS_VIRTUAL_OFFICE);
    } catch (error: any) {
      console.log(error.response);
    }
  };

  return (
    <div>
      <Flexed justifyCenter>
        <img src={warning3} alt='' style={{ width: 200 }} />
      </Flexed>

      <H3 center m='32px 0 10px 0' color={colors.neutral900}>
        {t('first_login.title')}
      </H3>

      <P2 mb='50' center color={colors.neutral900}>
        If you haven’t purchased Back-Office Subscription you
        <b>are no longer receiving</b>
      </P2>

      <Flexed alignStart gap='10px' mb='15'>
        <Icon>
          <IconXCircle />
        </Icon>
        <P1 color={colors.neutral900}>Commissionable Volume Points (CV)</P1>
      </Flexed>

      <Flexed alignStart gap='10px' mb='32'>
        <Icon>
          <IconXCircle />
        </Icon>
        <P1 color={colors.neutral900}>{dashboard('notifications.bonuses')} </P1>
      </Flexed>

      <Flexed mb='40' alignStart>
        <Checkbox
          checkColor={colors.primary900}
          margin={'0 10px 0 0'}
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
        />
        <P1 color={colors.neutral900}>
          I am aware, that without BO subscription I can lose CV points
          accumulation and bonuses
        </P1>
      </Flexed>

      <Button negative disabled={!checkbox} onClick={firstLogin}>
        {t('first_login.button')}
      </Button>
    </div>
  );
};
